export default __webpack_public_path__ + "static/media/uranus.46bdd529.png";